import React from 'react'
import Sip from '../tools/Calculator/sip'
// import Footer from './Home/footer/Footer'

const Tools = () => {
  return (
    <div><Sip/>
    
    </div>
  )
}

export default Tools